import { ProtectedRoute } from '../../../router/protectedrouter';
import MainLayout from '../../../components/layouts/MainLayoutPage';
import DashboardPage from '../components/DashboardPage';
import StandardsPage from '../components/StandardsPage';
import ViewControlsPage from '../components/ViewControlsPage';
import UPendingAssementsPage from '../components/user/PendingAssementsPage';
import UMitigationPlanPage from '../components/user/MitigationPlanPage';
import UHistoricalAssessmentPage from '../components/user/HistoricalAssessmentPage';
import AssignAssessmentPage from '../components/superuser/AssignAssessmentPage';
import SPendingAssementsPage from '../components/superuser/PendingAssementsPage';
import SMitigationPlanPage from '../components/superuser/MitigationPlanPage';
import SHistoricalAssessmentPage from '../components/superuser/HistoricalAssessmentPage';
import UserGuidePage from '../components/UserGuidePage';
import StandardsGuidePage from '../components/StandarsGuidePage'
import SReviewAssessmentPage from '../components/superuser/ReviewAssessmentPage';
import RejectAssessmentPage from '../components/superuser/RejectAssessmentPage';
import SAssignMitigationPage from '../components/superuser/AssignMitigationPage';
import SReviewMitigationPage from '../components/superuser/ReviewMitigationPage';
import CompleteReportDashboardPage from '../components/CompleteReportDashboardPage';
import ViewAssessmentPage from '../components/user/ViewAssessmentPage';
import SelfAssessmentPage from '../components/user/SelfAssessmentPage';
import SubmitMitigationResponsePage from '../components/user/SubmitMitigationResponsePage';
import ViewMitigationPage from '../components/user/ViewMitigationPage';
import AssessmentSuccessPage from '../components/AssessmentSuccessPage';
import MitigationSuccessPage from '../components/MitigationSuccessPage';
import RejectMitigationPage from '../components/superuser/RejectMitigationPage';
import ConfigureStandards from '../components/superadmin/ConfigureStandards';
import ConfigureControls from '../components/superadmin/ConfigureControls';
import ConfigureQuestions from '../components/superadmin/ConfigureQuestions';
import ConfigureNewStandard from '../components/superadmin/ConfigureNewStandard';

import ConfigureControlsWeightages from '../components/superadmin/ConfigureControlsWeightages';
import AdminConfigureStandards from '../components/admin/ConfigureStandards';
import AdminConfigureControls from '../components/admin/ConfigureControls';
import AdminConfigureQuestions from '../components/admin/ConfigureQuestions';
import ConfigureCompanyNewStandard from '../components/admin/ConfigureNewStandard';

import AdminConfigureControlsWeightages from '../components/admin/ConfigureControlsWeightages';
const base_url="/cap";
const routes = [
    {
        path: `${base_url}`,
        children:[
            {
                path: "dashboard",
                element: <ProtectedRoute> 
                            <MainLayout>
                                <DashboardPage/>
                            </MainLayout> 
                         </ProtectedRoute>,
                name: "cap-dashboard"
            },
            {
                path: "viewcontrols",
                element: <ProtectedRoute> 
                            <MainLayout>
                                <ViewControlsPage/>
                            </MainLayout> 
                         </ProtectedRoute>,
                name: "cap-view-controls"
            },
            {
                path: "standards",
                element: <ProtectedRoute> 
                            <MainLayout>
                                <StandardsPage/>
                            </MainLayout> 
                         </ProtectedRoute>,
                name: "cap-standards"
            },
            {
                path: "user-pendingassessments",
                element: <ProtectedRoute> 
                            <MainLayout>
                                <UPendingAssementsPage/>
                            </MainLayout> 
                         </ProtectedRoute>,
                name: "cap-user-pendingassessments"
            },
            {
                path: "user-mitigationplan",
                element: <ProtectedRoute> 
                            <MainLayout>
                                <UMitigationPlanPage/>
                            </MainLayout> 
                         </ProtectedRoute>,
                name: "cap-user-mitigationplan"
            },
            {
                path: "user-assessmentshistory",
                element: <ProtectedRoute> 
                            <MainLayout>
                                <UHistoricalAssessmentPage/>
                            </MainLayout> 
                         </ProtectedRoute>,
                name: "cap-user-assessmentshistory"
            },
            {
                path: "assign-assessment",
                element: <ProtectedRoute> 
                            <MainLayout>
                                <AssignAssessmentPage/>
                            </MainLayout> 
                         </ProtectedRoute>,
                name: "cap-assign-assessment"
            },
            {
                path: "pending-assessment",
                element: <ProtectedRoute> 
                            <MainLayout>
                                <SPendingAssementsPage/>
                            </MainLayout> 
                         </ProtectedRoute>,
                name: "cap-pending-assessment"
            },
            {
                path: "review-assessment",
                element: <ProtectedRoute> 
                            <MainLayout>
                                <SReviewAssessmentPage/>
                            </MainLayout> 
                         </ProtectedRoute>,
                name: "cap-review-assessment"
            },
         
            
            {
                path: "rejectassessment",
                element: <ProtectedRoute> 
                            <MainLayout>
                                <RejectAssessmentPage/>
                            </MainLayout> 
                         </ProtectedRoute>,
                name: "cap-rejectassessment"
            },
            {
                path: "assignmitigation",
                element: <ProtectedRoute> 
                            <MainLayout>
                                <SAssignMitigationPage/>
                            </MainLayout> 
                         </ProtectedRoute>,
                name: "cap-assignmitigation"
            },
            {
                path: "mitigationplan",
                element: <ProtectedRoute> 
                            <MainLayout>
                                <SMitigationPlanPage/>
                            </MainLayout> 
                         </ProtectedRoute>,
                name: "cap-mitigationplan"
            },
            {
                path: "mitigationreview",
                element: <ProtectedRoute> 
                            <MainLayout>
                                <SReviewMitigationPage/>
                            </MainLayout> 
                         </ProtectedRoute>,
                name: "cap-mitigationreview"
            },
            {
                path: "assessments-history",
                element: <ProtectedRoute> 
                            <MainLayout>
                                <SHistoricalAssessmentPage/>
                            </MainLayout> 
                         </ProtectedRoute>,
                name: "cap-assessments-history"
            },
            {
                path: "completereportdashboard",
                element: <ProtectedRoute> 
                            <MainLayout>
                                <CompleteReportDashboardPage/>
                            </MainLayout> 
                         </ProtectedRoute>,
                name: "cap-completereportdashboard"
            },
            {
                path: "user-viewassessment",
                element: <ProtectedRoute> 
                            <MainLayout>
                                <ViewAssessmentPage/>
                            </MainLayout> 
                         </ProtectedRoute>,
                name: "cap-user-viewassessment"
            },
            {
                path: "selfassessment",
                element: <ProtectedRoute> 
                            <MainLayout>
                                <SelfAssessmentPage/>
                            </MainLayout> 
                         </ProtectedRoute>,
                name: "cap-selfassessment"
            },
            {
                path: "usermitigation",
                element: <ProtectedRoute> 
                            <MainLayout>
                                <SubmitMitigationResponsePage/>
                            </MainLayout> 
                         </ProtectedRoute>,
                name: "cap-usermitigation"
            },
            {
                path: "viewmitigation",
                element: <ProtectedRoute> 
                            <MainLayout>
                                <ViewMitigationPage/>
                            </MainLayout> 
                         </ProtectedRoute>,
                name: "cap-viewmitigation"
            },
            {
                path: "userguide",
                element: <ProtectedRoute> 
                            <MainLayout>
                                <UserGuidePage/>    
                            </MainLayout> 
                         </ProtectedRoute>,
                name: "cap-userguide"
            },
            {
                path:"standardsguide",
                element:<ProtectedRoute>
                            <MainLayout>
                                <StandardsGuidePage/>
                            </MainLayout>
                        </ProtectedRoute>
            },
            {
                path :'completeassessment',
                element: <ProtectedRoute>
                    <MainLayout>
                        <AssessmentSuccessPage />
                    </MainLayout>
                </ProtectedRoute>,
               

            },
            
            {
                path :'mitigationsuccess',
                element: <ProtectedRoute>
                    <MainLayout>
                        <MitigationSuccessPage />
                    </MainLayout>
                </ProtectedRoute>,
               

            },
            {
                path :'rejectmitigation',
                element: <ProtectedRoute>
                    <MainLayout>
                        <RejectMitigationPage />
                    </MainLayout>
                </ProtectedRoute>,
               

            },
            {
                path :'configurestandards',
                element: <ProtectedRoute>
                    <MainLayout>
                        <ConfigureStandards />
                    </MainLayout>
                </ProtectedRoute>,
               

            },
            {
                path :'configurecontrols',
                element: <ProtectedRoute>
                    <MainLayout>
                        <ConfigureControls />
                    </MainLayout>
                </ProtectedRoute>,
               

            },
            {
                path :'configurecontrolsweightages',
                element: <ProtectedRoute>
                    <MainLayout>
                        <ConfigureControlsWeightages />
                    </MainLayout>
                </ProtectedRoute>,
               

            },
            {
                path :'configurequestions',
                element: <ProtectedRoute>
                    <MainLayout>
                        <ConfigureQuestions />
                    </MainLayout>
                </ProtectedRoute>,
               

            },
            {
                path :'adm-configurestandards',
                element: <ProtectedRoute>
                    <MainLayout>
                        <AdminConfigureStandards />
                    </MainLayout>
                </ProtectedRoute>,
            },
            {
                path :'adm-configurenewstandards',
                element: <ProtectedRoute>
                    <MainLayout>
                        <ConfigureCompanyNewStandard />
                    </MainLayout>
                </ProtectedRoute>,
            },
            {
                path :'configurenewstandards',
                element: <ProtectedRoute>
                    <MainLayout>
                        <ConfigureNewStandard />
                    </MainLayout>
                </ProtectedRoute>,
            },
            {
                path :'adm-configurecontrol',
                element: <ProtectedRoute>
                    <MainLayout>
                        <AdminConfigureControls />
                    </MainLayout>
                </ProtectedRoute>,
               

            },
            {
                path :'adm-configurecontrolsweightages',
                element: <ProtectedRoute>
                    <MainLayout>
                        <AdminConfigureControlsWeightages />
                    </MainLayout>
                </ProtectedRoute>,
               

            },
            {
                path :'adm-configurequestion',
                element: <ProtectedRoute>
                    <MainLayout>
                        <AdminConfigureQuestions />
                    </MainLayout>
                </ProtectedRoute>,
               

            },
            
          ]

    },
]


export default routes;